import {
    DIC
} from '@/const/dic'
import {
    formatterTime
} from '@/util/util'
import {
    baseUrl
} from '@/config/env';




export const stockMonitorDetailOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    columnBtn: false,
    // gutter: 180,
    menuWidth: '300',
    // labelPosition: 'top',
    labelWidth: '110',
    // menuType:'menu',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "商品名称",
            prop: "name",
            type: "input",
            span: 12,
            search: true
        },

        // {
        //     label: '产品型号',
        //     prop: 'type',
        //     type: "input"
        // },
        {
            label: '商品单位',
            prop: 'unit',
            span: 12,
            type: "input"
        },
        /* {
            label: '采购价格',
            prop: 'purchasePrice',
            span: 12,
            type: "input"
        },
        {
            label: '零售价格',
            prop: 'salePrice',
            span: 12,
            type: "input"
        }, */
        {
            label: '品牌名称',
            prop: 'brandName',
            span: 12,
            formsolt: true,
        },
        {
            label: '一级分类',
            prop: 'firstClassifyName',
            span: 12,
            type: "select",
        },
        {
            label: '二级分类',
            prop: 'secondClassifyName',
            span: 12,
            type: "select",
        },
        {
            label: 'SKU组合',
            prop: 'sku',
            hide: true,
            span: 12,
            formsolt: true
        },
       /*  {
            label: "商品属性和价格",
            labelPosition: "top",
            prop: "constitute",
            span: 24,
            solt: true,
            hide: true,
            formsolt: true
        },
        {
            label: "商品属性",
            prop: "properties",
            formsolt: true
        }, */
        {
            label: '总采购量',
            prop: 'allAmount',
            span: 12,
            type: 'input',
            addVisdiplay: false
        },
        {
            label: '现有库存',
            prop: 'amount',
            span: 12,
            type: 'input',
            addVisdiplay: false
        },
        {
            label: '商品状态',
            prop: 'productStatus',
            solt: true,
            span: 12,
            formsolt: true,
            hide: true,
            //addVisdiplay:false
        },
        {
            label: "上次采购时间",
            prop: "lastPurchaseTime",
            type: "datetime",
            // sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
       /*  {
            label: '出库人',
            prop: 'outPerson',
            addVisdiplay: false,
            search: true,
            editVisdiplay: false
        }, */
        {
            label: "商品详情",
            prop: "describeImgs",
            span: 24,
            hide: true,
            solt: true,
            formsolt: true
        },
        {
            label: "商品轮播",
            prop: "wheelsImgs",
            span: 24,
            solt: true,
            hide: true,
            formsolt: true
        },
        {
            label: "采购时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            hide: true,
            search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        }
    ]
};